import { createFileRoute } from '@tanstack/react-router';
import { validateProposalsSearch } from '@/lib/proposals/proposals-search';

// The list's filters live in the URL (status, deal reference): a deep link and the back button
// reproduce the same list. Neither is personal data.
export const Route = createFileRoute('/crm/proposals/')({
  validateSearch: validateProposalsSearch,
});
